document.addEventListener('DOMContentLoaded', function () {
  let cartDrawer = document.querySelector('.cart-drawer__content');

  function createOverlay() {
    const overlay = document.createElement('div');
    overlay.className = 'cart-loading-overlay';
    overlay.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: white;
      opacity: 0.5;
      z-index: 1000;
    `;
    return overlay;
  }

  function showLoadingOverlay() {
    const overlay = createOverlay();
    cartDrawer.style.position = 'relative';
    cartDrawer.appendChild(overlay);
    return overlay;
  }

  function hideLoadingOverlay(overlay) {
    if (overlay && overlay.parentNode) {
      overlay.parentNode.removeChild(overlay);
    }
  }

  async function fetchCartHTML() {
    try {
      const sectionId = document.querySelector('cart-items-component')?.dataset.sectionId;
      if (!sectionId) throw new Error('Could not find cart section ID');

      const response = await fetch(window.location.pathname + '?section_id=' + sectionId, {
        method: 'GET',
        headers: {
          'Content-Type': 'text/html',
        },
      });

      if (!response.ok) throw new Error('Failed to fetch cart');

      const html = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newCartComponent = doc.querySelector('cart-items-component');
      return newCartComponent;
    } catch (error) {
      console.error('Error fetching cart:', error);
      return null;
    }
  }

  async function notifyCartUpdated() {
    try {
      const response = await fetch(`${window.Theme.routes.cart_url}.js`);
      const cart = await response.json();

      const event = new Event('cart:update', { bubbles: true });
      event.detail = {
        resource: cart,
        sourceId: 'cart-drawer-upsell',
        data: { source: 'cart-drawer-upsell', itemCount: cart.item_count },
      };

      // Dispatch from the cart items element so it skips its own re-render (the drawer markup
      // was just replaced above) while the event still bubbles to the cart icon and buy buttons.
      const target = document.querySelector('cart-items-component') ?? document;
      target.dispatchEvent(event);
    } catch (error) {
      console.error('Error syncing cart state:', error);
    }
  }

  function updateCartDrawer(newCartComponent) {
    const currentCartComponent = document.querySelector('cart-items-component');

    if (currentCartComponent && newCartComponent) {
      currentCartComponent.outerHTML = newCartComponent.outerHTML;
      cartDrawer = document.querySelector('.cart-drawer__content');
    }
  }

  document.addEventListener('click', async function (event) {
    if (event.target.classList.contains('swaddle-variant') || event.target.closest('.swaddle-variant')) {
      const button = event.target.classList.contains('swaddle-variant')
        ? event.target
        : event.target.closest('.swaddle-variant');

      const allVariantButtons = document.querySelectorAll('.swaddle-variant');
      allVariantButtons.forEach((b) => b.classList.remove('active'));

      button.classList.add('active');

      const selectedVariantId = button.dataset.variantId;

      if (selectedVariantId) {
        const overlay = showLoadingOverlay();

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
          });

          if (!response.ok) throw new Error('Failed to add item to cart');

          const newCartComponent = await fetchCartHTML();
          if (newCartComponent) {
            updateCartDrawer(newCartComponent);
          }

          await notifyCartUpdated();
        } catch (error) {
          console.error('Error adding item to cart:', error);
          button.classList.remove('active');
        } finally {
          hideLoadingOverlay(overlay);
        }
      }
    }

    if (event.target.classList.contains('newborn-class-add-btn') || event.target.closest('.newborn-class-add-btn')) {
      const button = event.target.classList.contains('newborn-class-add-btn')
        ? event.target
        : event.target.closest('.newborn-class-add-btn');
      const selectedVariantId = button.dataset.variantId;

      if (selectedVariantId) {
        const overlay = showLoadingOverlay();

        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: selectedVariantId, quantity: 1 }),
          });

          if (!response.ok) throw new Error('Failed to add class to cart');

          const newCartComponent = await fetchCartHTML();
          if (newCartComponent) {
            updateCartDrawer(newCartComponent);
          }

          await notifyCartUpdated();
        } catch (error) {
          console.error('Error adding class to cart:', error);
        } finally {
          hideLoadingOverlay(overlay);
        }
      }
    }
  });
});
